<template>
  <div class="orgDetails app-container">
    <tabHeader
      :tab="tab"
      :title="`${$t('org.orgName')}：${$route.query.name}`"
      :slideData="slideData"
      @headerTabBack="headerTabBack"
    >
      <button
        class="global-button-style"
        @click="$router.push({ name: 'orgList' })"
      >
        {{ $t("commonMsg.back") }}
      </button>
    </tabHeader>
    <transition name="fade-transform" mode="out-in">
      <component :is="tab"></component>
    </transition>
  </div>
</template>

<script>
import tabHeader from "@/components/tabHeader";
import usersInfo from "./components/usersInfo";
import otherInfo from "./components/otherInfo";
export default {
  components: {
    tabHeader,
    usersInfo,
    otherInfo
  },
  computed: {
    slideData() {
      let slideData = [
        {
          name: this.$t("org.usersInfo"),
          component: "usersInfo"
        },
        {
          name: this.$t("org.otherInfo"),
          component: "otherInfo"
        }
      ];
      return slideData;
    }
  },
  data() {
    return {
      tab: this.$route.query.tab || "usersInfo"
    };
  },
  methods: {
    headerTabBack(item) {
      this.tab = item.component;
      this.$router.push({ query: { ...this.$route.query, tab: this.tab } });
    }
  }
};
</script>

<style lang="scss" scoped></style>
